import { ofType } from "redux-observable";
import { map, retry, switchMap } from "rxjs/operators";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { actionCoopAssignMemberRoleResponse, TypeActionCoopInfo, } from "../actionCoop";
export var epicCoopAssignMemberRole = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionCoopInfo.AssignRole), switchMap(function (action) {
        var coopId = action.coopId, playerId = action.playerId, playerIdToAssign = action.playerIdToAssign, roleId = action.roleId;
        return deps
            .netSend({
            id: CommandCode.AssignCoopMemberRole,
            props: {
                coopId: coopId,
                playerId: playerId,
                playerIdToAssign: playerIdToAssign,
                roleId: roleId,
            },
        })
            .pipe(retry(), map(actionCoopAssignMemberRoleResponse));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/epic/epicCoopAssignMemberRole.ts
// module id = 1797
// module chunks = 3